import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Category from "@/pages/category/page";
import Detail from "@/pages/detail/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import Special from "@/pages/special/page";
import SpecialDetail from "@/pages/special/detail/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:type", element: <Category /> },
      { path: "/detail/:id", element: <Detail /> },
      { path: "/news", element: <News /> },
      { path: "/news/detail/:id", element: <NewsDetail /> },
      { path: "/special", element: <Special /> },
      { path: "/special/:id", element: <SpecialDetail /> },
      { path: "/search", element: <Search /> },
      { path: "/about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;